module.exports = __webpack_public_path__ + "img/advantage6.0a1139ed.png";